// extracted by mini-css-extract-plugin
module.exports = {"rangeInput":"StepColorSliderHandle_rangeInput__1Z7o6","rangeColors":"StepColorSliderHandle_rangeColors__2o4nw","rangeWrap":"StepColorSliderHandle_rangeWrap__1Q4-n"};